import { FC, useEffect, useState } from "react";
import {
  Draggable,
  Droppable,
  DragDropContext,
  DropResult,
} from "react-beautiful-dnd";
import { ReactComponent as DragIcon } from "../../../assets/icons/drag.svg";
import { useSelector } from "react-redux";

import Select from "../../custom/select/select";

import { ISettingOptions } from "../../../types/interfaces";

import styles from "../headerBtn.module.scss";

interface IProps extends ISettingOptions {
  setReorderedReportOptions: (el: { value: string; label: string }[]) => void;
  selectedId: (id: number) => void;
}

const options = [
  { value: "project", label: "Проект" },
  { value: "contracts", label: "Контракт" },
  { value: "region", label: "Регион" },
  { value: "areas", label: "Область" },
  { value: "сhains", label: "Сеть" },
  { value: "date", label: "Период" },
];

const ChartsSettingsSection: FC<IProps> = ({
  setReorderedReportOptions,
  setIsCheckedFullInfo,
  setSelectedSettings,
  isCheckedFullInfo,
  selectedSettings,
  selectedId,
}) => {
  const { desktopList, listSetting, reorderedOptions, defaultDesktop } =
    useSelector((state: any) => state.charts?.chartsList);
  const desktop =
    desktopList.find(
      (el: { id: number }) => el.id.toString() === defaultDesktop
    ) || desktopList[0];
  const desktopOptions = desktopList.map((el: { name: string; id: number }) => {
    return { value: el.id, label: el.name };
  });

  const [select, setSelect] = useState<{ value: number; label: string }>({
    value: desktop.id,
    label: desktop.name,
  });
  const [filteredOptions, setFilteredOptions] =
    useState<{ value: string; label: string }[]>(options);

  const handleChangeCheckbox = (name: string) => {
    const updatedSettings = selectedSettings.includes(name)
      ? selectedSettings.filter((elem: string) => elem !== name)
      : [...selectedSettings, name];
    setSelectedSettings(updatedSettings);
    setIsCheckedFullInfo(updatedSettings.length === options.length);
  };

  const handleChangeFullInfoCheckbox = () => {
    if (!isCheckedFullInfo) {
      const allSettings = options.map((option) => option.value);
      setSelectedSettings(allSettings);
    } else {
      setSelectedSettings([]);
    }
    setIsCheckedFullInfo(!isCheckedFullInfo);
  };

  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) return;
    const optionsToUpdate: { value: string; label: string }[] =
      Array.from(filteredOptions);
    const [movedOption] = optionsToUpdate.splice(result.source.index, 1);
    optionsToUpdate.splice(result.destination.index, 0, movedOption);
    setReorderedReportOptions(optionsToUpdate);
    setFilteredOptions(optionsToUpdate);
  };

  const handleResetOrder = () => {
    setFilteredOptions(options);
    setReorderedReportOptions(options);
  };

  useEffect(() => {
    filteredOptions && setReorderedReportOptions(filteredOptions);
  }, [filteredOptions, setReorderedReportOptions]);

  useEffect(() => {
    setSelectedSettings(listSetting);
    selectedId(select.value);
    if (reorderedOptions && reorderedOptions.length) {
      const updatedOptions = reorderedOptions.map(
        (option: { value: string; label: string }) => {
          if (option.value === "contracts" && option.label === "Контракты") {
            return { value: "contracts", label: "Контракт" };
          }
          return option;
        }
      );
      setFilteredOptions(updatedOptions);
    }
    // eslint-disable-next-line
  }, [select]);

  useEffect(() => {
    setIsCheckedFullInfo(listSetting.length === options.length);
    // eslint-disable-next-line
  }, []);

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <div className={styles.settings__block_info}>
        <Droppable droppableId="options">
          {(provided) => (
            <div
              {...provided.droppableProps}
              ref={provided.innerRef}
              className={styles.check__list_block}
            >
              <div className={styles.settings__select}>
                <span>
                  Рабочий стол <small>(по умолчанию)</small>
                </span>
                <Select
                  options={desktopOptions}
                  propsChange={(event: { value: number; label: string }) => {
                    setSelect(event);
                    selectedId(event.value);
                  }}
                  value={select}
                  placeholder={select}
                  className="users__filter"
                  name="desktop"
                  isShowPlaceholder={true}
                />
              </div>
              {filteredOptions?.map(
                (option: { value: string; label: string }, index: number) => (
                  <Draggable
                    draggableId={index.toString()}
                    index={index}
                    key={index}
                  >
                    {(provided) => (
                      <div
                        ref={provided.innerRef}
                        {...provided.draggableProps}
                        {...provided.dragHandleProps}
                        className={styles.check__list_elem}
                      >
                        <label className={styles.checkbox__container}>
                          <input
                            checked={
                              selectedSettings &&
                              selectedSettings?.includes(option.value)
                            }
                            type="checkbox"
                            onChange={() => handleChangeCheckbox(option.value)}
                          />
                          <span
                            className={styles.multi__reason_checkmark}
                          ></span>
                        </label>
                        {option.label}
                        <DragIcon className={styles.icon} />
                      </div>
                    )}
                  </Draggable>
                )
              )}
              {provided.placeholder}
              <div className={styles.check__list_elem}>
                <label className={styles.checkbox__container}>
                  <input
                    type={"checkbox"}
                    onChange={handleChangeFullInfoCheckbox}
                    checked={isCheckedFullInfo}
                  />
                  <span className={styles.multi__reason_checkmark}></span>
                </label>
                Все
              </div>
              <button
                className={styles.reset__order_btn}
                onClick={handleResetOrder}
              >
                Сбросить расположение блоков
              </button>
            </div>
          )}
        </Droppable>
      </div>
    </DragDropContext>
  );
};

export default ChartsSettingsSection;
